export default __webpack_public_path__ + "static/media/ClienteEmpty.372e7c87.svg";